import LogoImage from "../../images/logo.svg?react";
import { Link } from "react-router-dom";
import { FC } from "react";
import "./Logo.css";

const Logo: FC = () => {
  return (
    <Link to="/" className="logo">
      <LogoImage />
    </Link>
  );
};

export default Logo;
